module.exports = __webpack_public_path__ + "static/zdjęcia2-5d7c670fb1fdbdf01de04ce30d5fd3ab.svg";